export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6878.9436e823.jpg";